import React from 'react';
import { getActiveItems } from '../service/ItemService';
import ClipLoader from "react-spinners/ClipLoader";
import ItemForPicker from './ItemForPicker';

class ItemPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = { items: [] }
    }

    componentDidMount(){
        getActiveItems().then(data => {
            //console.log("active items", data);
            this.setState({items: data});
        });
    }
    selectItem(itemObj){
        this.props.handleSubmitClick(itemObj);
    }
    render() { 
        return ( 
            <div style={{width:'100%'}}>
                <div className="kwizda-home-item-container">
                {this.state.items && this.state.items.map((itemObj, i)=> (
                    <ItemForPicker key={i} item={itemObj} loggedIn={this.props.loggedIn} 
                        handleSubmitClick={() => this.selectItem(itemObj)} ></ItemForPicker>
                    )
                )}
                </div>
                {this.state.items && <div>
                    <button className="kwizda-back-button" 
                        id="kwizda-itempicker-back-button"
                        onClick={()=>this.props.handleBackClick()}>Vissza</button>
                </div>
                }
                <ClipLoader loading={this.state.items.length === 0} size={80} />   
            </div>
         );
    }
}
 
export default ItemPicker;